import { resumeLessonRoute } from './resumeLessonRoute.mjs';

// Reuse the punctual return decision before requesting any teaching change.
export async function adaptLessonRoute({ lesson, teachingLevel, teachingGoal, locate, request, isCurrent }) {
  const normalizedGoal = teachingGoal === undefined ? undefined : String(teachingGoal).trim().replace(/\s+/g, ' ');
  if (teachingGoal !== undefined && (!normalizedGoal || normalizedGoal.length > 240))
    throw new Error('Choose a teaching goal of 1 to 240 characters.');
  if (teachingLevel !== undefined && (!Number.isInteger(teachingLevel) || teachingLevel < 1 || teachingLevel > 4))
    throw new Error('Choose a challenge level from 1 to 4.');
  const result = await resumeLessonRoute({
    lesson, locate, isCurrent,
    request: (action, location) => action === 'recover-route'
      ? request('adapt-route', { ...location, expected_started_at: lesson.started_at,
          ...(teachingLevel !== undefined ? { teaching_level: teachingLevel } : {}),
          ...(normalizedGoal !== undefined ? { teaching_goal: normalizedGoal } : {}) })
      : request(action, location),
  });
  if (!result.saved_plan.return_mode && teachingLevel !== undefined
      && (result.teaching_level !== teachingLevel || result.route_plan.level !== teachingLevel))
    throw new Error('The selected level could not be confirmed.');
  if (!result.saved_plan.return_mode && normalizedGoal !== undefined
      && result.active_teaching_goal !== normalizedGoal)
    throw new Error('The selected teaching goal could not be confirmed.');
  return result;
}
